var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreOffFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.111 21.802a9.6 9.6 0 0 1-3.856-.78 10 10 0 0 1-3.14-2.116 10 10 0 0 1-2.114-3.144 9.65 9.65 0 0 1-.778-3.861q0-1.485.42-2.859t1.211-2.587L2.297 4.896A.96.96 0 0 1 2 4.191q0-.41.297-.706A.96.96 0 0 1 3 3.188q.408 0 .705.297l16.81 16.832a.95.95 0 0 1 .297.693.95.95 0 0 1-.296.693.96.96 0 0 1-.705.297.96.96 0 0 1-.704-.297l-1.558-1.535a10.1 10.1 0 0 1-2.583 1.213q-1.372.42-2.856.421m-3.584-5.693 3.065-.866a.44.44 0 0 0 .334-.36.5.5 0 0 0-.136-.482l-2.176-2.178a.49.49 0 0 0-.482-.136.44.44 0 0 0-.358.334l-.865 3.07a.47.47 0 0 0 .135.482q.21.21.483.136m11.57.445q-.248 0-.47-.086a1.2 1.2 0 0 1-.42-.285l-3.585-3.589a.95.95 0 0 1-.26-.445 1 1 0 0 1 .012-.52l.94-3.317a.47.47 0 0 0-.136-.483.47.47 0 0 0-.482-.136l-3.313.94q-.272.075-.519.013a.95.95 0 0 1-.445-.26L7.834 4.797a1.3 1.3 0 0 1-.284-.408 1.2 1.2 0 0 1-.086-.458q0-.347.173-.631t.494-.458a9.5 9.5 0 0 1 1.94-.632 10 10 0 0 1 2.04-.21 9.6 9.6 0 0 1 3.857.78 10 10 0 0 1 3.14 2.116A10 10 0 0 1 21.22 8.04 9.65 9.65 0 0 1 22 11.9q0 1.04-.21 2.042a9.6 9.6 0 0 1-.63 1.943 1.02 1.02 0 0 1-.433.508q-.285.16-.63.16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreOffFill);
export default __webpack_public_path__ + "static/media/explore_off_fill.c50aa9dfe4b30552897a97be41325fa3.svg";
export { ForwardRef as ReactComponent };